<template>
  <div class="form_content_select">
    <label>{{title}}</label>
    <div class="form_content_center" @click="showlist">
      <input type="text" v-model='selectcontent' placeholder="请选择">
      <!-- <span>{{selectcontent}}</span> -->
      <img src="../../assets/pulldown.svg" alt="">
      <ul v-if="selected" >
        <li v-for="(item,index) in lidata" :key='index' @click="choosedata(item.name,index)" :class="`${index==number?'form_content_li':''} `">{{item.name}}</li>
      </ul>
    </div>
  </div>   
</template>

<script>
export default {
  name:'choosebox',
  props:['lidata','title','ind','selected'],
  data(){
    return{
      selectcontent:'',
      listtable:false,
      number:10
    }
  },
  methods:{
    showlist(){
      this.$emit('click', this.selectcontent)
    },
    choosedata(value,index){
      this.number=index
      this.selectcontent=value
    }
  }
}
</script>

<style scoped>
.form_content_select{
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom:15px ;
}
.form_content_center{
  width: 566px;
  height: 44px;
  border: 1px solid rgba(151,151,151,0.5);
  border-radius: 8px;
  margin-left: 15px;
  padding: 0 18px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: rgba(0,0,0,0.28);
  font-weight: 400;
  line-height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  position: relative;
  flex-wrap: wrap;
}
.form_content_li{
  background: #FC5322;
  color: #ffffff!important;
}
.form_content_li:hover{
  background: #FC5322!important;
}
.form_content_center:hover{
  border: 1px solid rgba(252,83,34,1);
}
.form_content_center img{
  width: 16px;
  height: 16px;
}
.form_content_center li{
  width: 566px;
  height: 34px;
  padding: 0 18px;
  line-height: 34px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0,0,0,0.65);
  font-weight: 400;
}
.form_content_center li:hover{
  background: rgba(0,0,0,0.06);
}
.form_content_center ul{
  background: #ffffff;
  width: 566px;
  box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05);
  position: absolute;
  left: 0;
  top: 50px;
  z-index: 99999;
}
label{
  text-align: right;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #222536;
  letter-spacing: 0.28px;
  font-weight: 400;
  display: inline-block;
  width: 163px;
}
input{
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: 400;
}
input::-webkit-input-placeholder{
  color: rgba(0,0,0,0.28);
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
  color: rgba(0,0,0,0.28);
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  color: rgba(0,0,0,0.28);
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
  color: rgba(0,0,0,0.28);
}
@media(max-width:767px){
  .form_content_select{
    display: block;
    margin-bottom:.15rem;
  }
  .form_content_center{
    width: 100%;
    height: .54rem;
    border: .01rem solid rgba(151,151,151,0.5);
    border-radius: .08rem;
    margin-left: 0;
    padding:0 .18rem;
    font-size: .16rem;
    line-height: .44rem;
  }
  .form_content_center img{
    width: .16rem;
    height: .16rem;
  }
  .form_content_center li{
    width: 100%;
    height: .42rem;
    padding: 0 .18rem;
    line-height: .42rem;
    font-size: .2rem;
  }
  .form_content_center li:hover{
    background: rgba(0,0,0,0.06);
  }
  .form_content_center ul{
    width: 100%;
    top: .6rem;
    border-radius: .02rem;
    box-shadow: 0px .09rem .28rem .08rem rgba(0,0,0,0.05);
  }
  label{
    font-size: .23rem;
    letter-spacing: 0.0028rem;
    width: auto;
    margin-bottom: .15rem;
  }
  input{
    font-size: .2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/choosebox.vue